// extracted by mini-css-extract-plugin
export default {"root":"Action_root__-+WQj","rejectBtn":"Action_rejectBtn__Qhrj+","placeHolderShimmer":"Action_placeHolderShimmer__QGtpY"};